export enum NumberTypeEnum {
    decimal ,
    integer,
    currency
}
